export const EDUCATION_LEVELS = [
  { value: 'ป.1', label: 'ประถมศึกษาปีที่ 1' },
  { value: 'ป.2', label: 'ประถมศึกษาปีที่ 2' },
  { value: 'ป.3', label: 'ประถมศึกษาปีที่ 3' },
  { value: 'ป.4', label: 'ประถมศึกษาปีที่ 4' },
  { value: 'ป.5', label: 'ประถมศึกษาปีที่ 5' },
  { value: 'ป.6', label: 'ประถมศึกษาปีที่ 6' },
  { value: 'ม.1', label: 'มัธยมศึกษาปีที่ 1' },
  { value: 'ม.2', label: 'มัธยมศึกษาปีที่ 2' },
  { value: 'ม.3', label: 'มัธยมศึกษาปีที่ 3' },
  { value: 'ม.4', label: 'มัธยมศึกษาปีที่ 4' },
  { value: 'ม.5', label: 'มัธยมศึกษาปีที่ 5' },
  { value: 'ม.6', label: 'มัธยมศึกษาปีที่ 6' },
  { value: 'มหาวิทยาลัย', label: 'มหาวิทยาลัย' },
] as const;

export const WEEKDAYS = [
  { key: '1', value: 1, label: 'จันทร์' },
  { key: '2', value: 2, label: 'อังคาร' },
  { key: '3', value: 3, label: 'พุธ' },
  { key: '4', value: 4, label: 'พฤหัสบดี' },
  { key: '5', value: 5, label: 'ศุกร์' },
  { key: '6', value: 6, label: 'เสาร์' },
  { key: '0', value: 0, label: 'อาทิตย์' },
] as const;

export const COURSE_TYPES = [
  { value: 'REGULAR', label: 'Regular' },
  { value: 'INTER', label: 'Inter' },
] as const;

export const CLASS_TYPES = [
  { value: 'PREMIER', label: 'Premier' },
  { value: 'PRIVATE', label: 'Private' },
] as const;

export const CLASS_LANGUAGES = [
  { value: 'THAI', label: 'ไทย' },
  { value: 'ENGLISH', label: 'English' },
] as const;

export const ROOMS = Array.from({ length: 90 }, (_, i) => ({
  value: `Room ${i + 1}`,
  label: `Room ${i + 1}`,
}));

export const LOCATIONS = [
  { value: 'ออนไลน์', label: 'ออนไลน์' },
  { value: 'สยาม', label: 'สยาม' },
  { value: 'งามวงศ์วาน', label: 'งามวงศ์วาน' },
  { value: 'ทรูอโศก', label: 'ทรูอโศก' },
] as const;

export type Location = typeof LOCATIONS[number]['value'];

export type CourseType = typeof COURSE_TYPES[number]['value'];
export type ClassType = typeof CLASS_TYPES[number]['value'];
export type ClassLanguage = typeof CLASS_LANGUAGES[number]['value'];
export type EducationLevel = typeof EDUCATION_LEVELS[number]['value'];
